import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SoundOff from '../components/soundOff/SoundOff';
import StaticProfile from '../components/profile/StaticProfile';
import ProfileSkeleton from '../util/ProfileSkeleton';

//mui
import Grid from '@material-ui/core/Grid';

//redux

import { connect } from 'react-redux';
import { getUserData } from '../redux/actions/dataActions';



class user extends Component {

    constructor(props) {
        super(props);
        this.state = {
            profile: null,
            soundOffIdParam: null
        };
    }

    componentDidMount() {
        const handle = this.props.match.params.handle;
        const soundOffId = this.props.match.params.soundOffId;
        //checks if user requested specific post
        if (soundOffId) {
            this.setState(() => {
                return {
                    soundOffIdParam: soundOffId
                }
            })
        }
        this.props.getUserData(handle);
        axios.get(`/users/${handle}`).then((res) => {
            this.setState(() => {
                return {
                    profile: res.data.user
                }
            })
        }).catch((err) => console.log(err))
    }
    render() {
        const { soundOffs, loading } = this.props.data;
        const { soundOffIdParam } = this.state;


        const soundOffsMarkup = loading ? (
            <ProfileSkeleton />
        ) : soundOffs === null ? (
            <p>no sound offs from this user :(</p>
        ) : !soundOffIdParam ? (
            soundOffs.map(soundOff => <SoundOff soundOff={soundOff} key={soundOff.soundOffId} />)) : (
                        soundOffs.map((soundOff) => {
                            if (soundOff.soundOffId !== soundOffIdParam) {
                                return (<SoundOff soundOff={soundOff} key={soundOff.soundOffId} />)
                            } else {
                                return (<SoundOff key={soundOff.soundOffId} soundOff={soundOff} openDialog />)
                            }
                        })
                    )
        return (
            <Grid container spacing={6}>
                <Grid item sm={8} xs={12} >
                    {soundOffsMarkup}
                </Grid>
                <Grid item sm={4} xs={12} >
                    {this.state.profile === null ? (
                        <ProfileSkeleton />
                    ) : (
                            <StaticProfile profile={this.state.profile} />
                        )}
                </Grid>
            </Grid>
        )
    }
}

user.propTypes = {
    getUserData: PropTypes.func.isRequired,
    data: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    data: state.data
})

export default connect(mapStateToProps, { getUserData })(user);
